export const TAX_TYPE_OPTIONS = [
  'County Sales',
  'City Sales',
  'State Sales',
  'Special District',
] as const
